export default __webpack_public_path__ + "static/media/reunion23_w1024.aebd686b.jpg";